import React from 'react';

// styles
import './YcProject.scss';


export const YcProject = (
  class YcProjectClass extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        detailsDisplay: false,
      }
    }

    render() {
      return (
        <div className="c-project">
          <img
            className="swipe-img"
            src={this.props.project.img}
            alt={this.props.project.title}
          />
          <div
            className="swipe-dialog"
          >
            <div className="swipe-text">
              <div className="title">{this.props.project.title}</div>
              <div className="purpose">OBJECTIF</div>
              <div className="desc-slide">{this.props.project.desc}</div>
            </div>
          </div>
        </div>
      );
    }
  }
);